export class LoginInfo {
    shopName: string;
    username: string;
    password: string;
    constructor(shopName: string, username: string, password: string) {
        this.shopName = shopName;
        this.username = username;
        this.password = password;
    }
}